<div class="container-fluid su-img-reference-wrapper">
  <img src="../../../../../assets/themepuro/img/app-referent.png" alt="logo">
</div>